<template>
    <!-- Footer Start -->
    <footer class="footer mt-auto py-3 bg-white text-center">
            <div class="container">
                <span class="text-muted"> Copyright © <span>{{ year }}</span> <a
                        href="javascript:void(0);" class="text-dark fw-semibold">MyDIT</a>
                </span>
            </div>
        </footer>
        <!-- Footer End -->
</template>
<script setup lang="ts">
const year = new Date().getFullYear()
</script>